var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 15L21 8.99997M3.75 32.25L8.82655 31.6859C9.44679 31.617 9.75691 31.5825 10.0468 31.4887C10.3039 31.4054 10.5487 31.2878 10.7743 31.139C11.0287 30.9713 11.2493 30.7507 11.6906 30.3094L31.5 10.5C33.1569 8.84311 33.1569 6.15682 31.5 4.49997C29.8432 2.84311 27.1569 2.84311 25.5 4.49996L5.69059 24.3094C5.24932 24.7506 5.02868 24.9713 4.86096 25.2256C4.71215 25.4513 4.59452 25.696 4.51127 25.9532C4.41743 26.2431 4.38298 26.5532 4.31406 27.1734L3.75 32.25Z",
    stroke: "#963A72",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycEdit);
export default __webpack_public_path__ + "static/media/kyc-edit.65fe637690bad1b21ebc8c4333a6d193.svg";
export { ForwardRef as ReactComponent };